/** t378u: the workspace's billing (self-serve trials and subscriptions). Enterprise workspaces answer mode 'enterprise'. */
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { useWorkspaceId } from '@/lib/hooks';

export const billingKey = (ws: string) => ['workspace-billing', ws] as const;

export function useBilling(enabled = true) {
  const ws = useWorkspaceId();
  return useQuery({ queryKey: billingKey(ws ?? ''), queryFn: () => api.workspaceBilling(ws!), enabled: Boolean(ws) && enabled, staleTime: 60_000, retry: 1 });
}

/** Leave for Stripe (Checkout or the customer portal). */
export function goTo(url: string) { window.location.assign(url); }
